
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "../../baseApiClient";
import { logger } from "@/lib/logger";

/**
 * Updates the onboarding completion status for a business
 */
export async function updateOnboardingStatus(
  businessId: string,
  isComplete: boolean
): Promise<boolean> {
  return BaseApiClient.request<boolean>(
    `business:onboarding:${businessId}`,
    async () => {
      try {
        const { error } = await supabase
          .from('business')
          .update({ is_onboarding_complete: isComplete })
          .eq('id', businessId);
          
        if (error) {
          throw new Error(`Failed to update onboarding status: ${error.message}`);
        }
        
        // Clear cache for related queries
        BaseApiClient.clearCache(`business:${businessId}`);
        BaseApiClient.clearCache(`business:owner:`);
        
        return true;
      } catch (error) {
        logger.error({
          message: "Error updating onboarding status",
          error: error instanceof Error ? error : new Error(String(error)),
          context: { businessId, isComplete }
        });
        return false;
      }
    }
  );
}
